module.exports = {"title":"Week 1: The Start","body":"<p>This week we spent listening to project proposals and solidifying our team.  We were mainly interested in Dr. Sirovic’s presentation and planned on trying to get onto her project.  We got into contact with her and received the rough outline of what we would be doing throughout the quarter.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./process/week-1/index.md
// module id = 492
// module chunks = 0